<template>
  <v-card v-if="cashin">
    <suspicion-details :is-active.sync="showSuspicionInfo" :details="getSuspicionDetail" />
    <bypass-comment
      :is-active.sync="showBypassComment"
      :transaction="this.cashin"
      @commented="bypassCommented"
    />
    <rejection-comment
      :is-active.sync="showRejectionComment"
      :transaction="this.cashin"
      @commented="rejectCommented"
    />
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold"> PayIn Details </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <ReindexButton :paymentId="cashin.payin.id" />

      <div v-if="cashin.done_at != null">
        <v-btn color="primary" :disabled="cashin.done_at == null" @click="downloadInvoice">
          <v-icon> mdi-download </v-icon>
          Download receipt
        </v-btn>
      </div>
      <v-spacer v-if="showStartTransferBtn"></v-spacer>
      <div v-if="cashin.payin.status === 'completed'">
        <v-btn
          v-if="showStartTransferBtn && cashin.status !== 'suspicious'"
          color="primary"
          :loading="completingTransfer"
          :disabled="cashin.started_at !== null || cashin.status === 'rejected'"
          @click="startTransfer"
        >
          <v-icon> mdi-progress-upload </v-icon>
          Start Transfer
        </v-btn>
      </div>
      <v-spacer v-if="showStartTransferBtn"></v-spacer>
      <div v-if="cashin.payin.status == 'completed'">
        <v-btn
          v-if="showStartTransferBtn && cashin.status !== 'suspicious'"
          color="primary"
          :loading="standingByTransfer"
          :disabled="
            cashin.started_at !== null ||
            cashin.status === 'standby' ||
            cashin.status === 'rejected'
          "
          @click="standbyTransfer"
        >
          <v-icon> mdi-power-standby </v-icon>
          Standby Transfer
        </v-btn>
      </div>
      <v-spacer v-if="showStartTransferBtn"></v-spacer>
      <div v-if="cashin.payin.status == 'completed'">
        <v-btn
          v-if="showStartTransferBtn && cashin.status !== 'suspicious'"
          color="primary"
          :loading="pendingPaymentTransfer"
          :disabled="
            cashin.started_at !== null ||
            cashin.status === 'pending' ||
            cashin.status === 'rejected'
          "
          @click="pendingTransfer"
        >
          <v-icon> mdi-clock-outline </v-icon>
          Pending Payment
        </v-btn>
      </div>
      <v-spacer v-if="showStartTransferBtn"></v-spacer>
      <v-btn
        color="primary"
        :loading="isArchiving"
        v-if="cashin.payin.status === 'pending'"
        @click="completePayin"
      >
        <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
        Complete Payin
      </v-btn>
      <v-spacer></v-spacer>
      <div v-if="canRetryDeposit">
        <v-btn
          v-if="
            (cashin.payin.done_at !== null && cashin.done_at === null) || !!cashin.status == 'error'
          "
          class="mr-3"
          color="primary"
          :loading="isRetrying"
          @click="retryDeposit"
          :disabled="isArchived"
        >
          <v-icon color="light-blue lighten-4">mdi-sync</v-icon>
          Retry Payin
        </v-btn>
      </div>
      <v-spacer v-if="cashinIsStuck"></v-spacer>
      <v-menu open-on-hover bottom offset-y v-if="cashin.status == 'suspicious'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            <v-icon color="light-blue lighten-4">mdi-sync</v-icon>
            More actions
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title
              class="v-list-item--link"
              @click="retrySuspiciousDeposit"
              :loading="isRetryingSuspicious"
              :disabled="isArchived"
            >
              Bypass suspicion
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title
              v-if="cashin.status == 'suspicious' && cashin.status != 'rejected'"
              class="v-list-item--link"
              @click="rejectDeposit"
              :loading="isRejecting"
              :disabled="isArchived"
            >
              Reject
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer v-if="cashinIsStuckSuspicious"></v-spacer>
      <v-btn color="primary" :loading="isArchiving" :disabled="isArchived" @click="archiveCashin">
        <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
        Archive payin
      </v-btn>
      <v-btn color="primary ml-3" :loading="isRestoring" v-if="isArchived" @click="restorecashin">
        <v-icon color="light-blue lighten-4">mdi-restore</v-icon>
        Restore
      </v-btn>
    </v-toolbar>

    <!-- cashin info -->
    <v-divider />
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <h2 class="subtitle-2 text-uppercase">General Information</h2>
          <key-value title="Amount" :value="transactionKey('amount_without_fee')" type="date">
            €{{ transactionKey("amount_without_fee") }}
          </key-value>
          <key-value title="Fees" :value="transactionKey('applied_fee')" type="date">
            €{{ transactionKey("applied_fee") }}
          </key-value>
          <key-value title="Number of Danacoins" :value="transactionKey('amount_in_danacoin')" />
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col cols="6">
              <h2 class="subtitle-2 text-uppercase">Payment Information</h2>
              <key-value title="Payment ID">
                <span class="small" v-text="transactionKey('payin.id')"></span>
              </key-value>
              <key-value title="Status" :value="transactionKey('payin.status')" />
              <key-value title="Payment Type" :value="transactionKey('payin.type')" />
            </v-col>
            <v-col cols="6">
              <key-value
                title="Payin Done At"
                :value="transactionKey('payin.done_at')"
                type="date"
              />
              <key-value
                title="Cashin Started At"
                :value="transactionKey('started_at')"
                type="date"
              />
              <key-value title="Cashin Done At" :value="transactionKey('done_at')" type="date" />
              <key-value title="Cashin Status" :value="transactionKey('status')" type="date" />
              <v-icon
                color="warning"
                v-if="transactionKey('status') == 'suspicious'"
                @click="suspicionInfo"
                >mdi-information-outline
              </v-icon>
              <key-value title="Auto start cashin in" :value="autoStartCountdown" type="hm" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import ReindexButton from "../../components/forms/ReindexButton.vue";
import moment from "moment-timezone";
export default {
  components: {
    ReindexButton,
    SuspicionDetails: require("./suspicionDetails").default,
    BypassComment: require("./bypassComment").default,
    RejectionComment: require("./rejectionComment").default,
  },
  props: {
    dataTransaction: {
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      cashin: this.dataTransaction,
      completingTransfer: false,
      isArchived: this.dataTransaction.isArchived || false,
      bankAccount: {},
      isArchiving: false,
      isRestoring: false,
      isRetrying: false,
      isRetryingSuspicious: false,
      standingByTransfer: false,
      pendingPaymentTransfer: false,
      showSuspicionInfo: false,
      autoStartCountdown: "00:00",
      showBypassComment: false,
      isRejecting: false,
      showRejectionComment: false,
    };
  },
  computed: {
    canRetryDeposit() {
      const { status, last_run_stage, applied_fee } = this.cashin;
      const { status: payinStatus } = this.cashin.payin;

      const isStartedWithoutStage = status === "started" && last_run_stage === null;
      const isStartedWithFeeAndNotLastStage =
        status === "started" &&
        +applied_fee > 0 &&
        last_run_stage !== "Transactions\\Stages\\Transfer\\TransferDanacoinDepositFee";
      const isPayinError = payinStatus === "error";

      return isStartedWithoutStage || isStartedWithFeeAndNotLastStage || isPayinError;
    },
    showStartTransferBtn() {
      return (
        this.cashin.status !== "rejected" &&
        (this.cashin.payin.provider === "SEPA" ||
          (this.cashin.payin.provider === "SEPA" && this.cashin.payin.status === "completed") ||
          this.cashin.payin.type === "instant_bank_transfer" ||
          (this.cashin.payin.type === "instant_bank_transfer" &&
            this.cashin.payin.status === "completed"))
      );
    },
    cashinIsStuck() {
      const status = this.transactionKey("status");
      if (status === "started" || status === "error") {
        return true;
      }
      return false;
    },
    cashinIsStuckSuspicious() {
      const status = this.transactionKey("status");
      if (status === "suspicious") {
        return true;
      }
      return false;
    },
    getSuspicionDetail() {
      const getSuspicionKey = (data, key) => {
        let obj = {};
        for (let k of data.RegistreDetail) {
          for (let k2 of k.Valeur) {
            for (let k3 in k2) {
              obj[k3] = k2[k3];
            }
          }
        }
        if (key in obj) {
          return obj[key];
        }
      };
      let reasons = [];
      if (this.cashin.source_client.criminal_cases.length > 0) {
        let source_motif = JSON.parse(this.cashin.source_client.criminal_cases[0].data);
        let parsed_source_motif = getSuspicionKey(source_motif, "Motifs");
        let str_source_motif = `${this.cashin.source_user.full_name} : ${parsed_source_motif}`;
        reasons.push(str_source_motif);
      }
      if (this.cashin.destination_client.criminal_cases.length > 0) {
        let destination_motif = JSON.parse(this.cashin.destination_client.criminal_cases[0].data);
        let parsed_destination_motif = getSuspicionKey(destination_motif, "Motifs");
        let str_destination_motif = `${this.cashin.destination_user.full_name} : ${parsed_destination_motif}`;
        reasons.push(str_destination_motif);
      }
      let other_reason = this.cashin.history.find(
        (it) => it.changes && it.changes.after && it.changes.after.is_suspicious,
      );
      if (other_reason) {
        reasons.push(other_reason.changes.after.reason);
      }
      return reasons.join("\n");
    },
  },
  created() {
    const id = this.cashin.payin.data.bank_account_id;
    if (id != undefined) {
      this.$http
        .get(`/api/v1/userBankAccounts/${id}`)
        .then((account) => (this.bankAccount = account))
        .catch((error) => Notify.error(error.message));
    }
    if (this.cashin.payin.status === "completed" && (this.transaction.status === "pending" || this.transaction.status === "standby")) {
      if (
        this.cashin.payin.data.transfer &&
        moment().isBefore(moment.tz(this.cashin.payin.data.transfer.standby, "Africa/Kampala"))
      ) {
        setInterval(() => {
          this.autoStartCountdown = moment
            .utc(moment().diff(moment.tz(this.cashin.payin.data.transfer.standby, "Africa/Kampala")))
            .format("mm:ss");
        }, 1000);
      } else {
        setInterval(() => {
          if (
            moment.tz(this.cashin.payin.done_at, "Africa/Kampala")
              .add(parseInt(this.cashin.transfer_pending_maximum_delay), "minutes")
              .isAfter(moment())
          ) {
            this.autoStartCountdown = moment
              .utc(
                moment.tz(this.cashin.payin.done_at, "Africa/Kampala")
                  .add(parseInt(this.cashin.transfer_pending_maximum_delay), "minutes")
                  .diff(moment()),
              )
              .format("mm:ss");
          } else {
            this.autoStartCountdown = moment
              .utc(
                moment().diff(
                  moment.tz(this.cashin.payin.done_at, "Africa/Kampala").add(
                    parseInt(this.cashin.transfer_pending_maximum_delay),
                    "minutes",
                  ),
                ),
              )
              .format("HH:mm:ss");
          }
        }, 1000);
      }
    }
  },

  methods: {
    completePayin() {
      const id = this.cashin.payin.id;
      if (!id) {
        return;
      }
      Notify.confirm(`Marking this payment as complete`).then(() => {
        this.$http
          .post(`/api/v1/payments/complete/${id}`)
          .then(() => {
            Notify.success("Transaction has been completed successfully!");
            // this.$router.push({ name: "transfers.index" });
            window.location.reload();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
    archiveCashin() {
      const id = this.cashin.payin.id;
      if (!id) {
        return;
      }
      Notify.confirm(`Archieving the transaction will hide it from the list of transactions`).then(
        () => {
          this.isArchiving = true;
          this.$http
            .delete(`/api/v1/payments/${id}`)
            .then(() => {
              Notify.success("Transaction was archived successfully!");
              this.$router.push({ name: "transfers.index" });
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error) => {
              this.archived = false;
              // console.error(error);
              Notify.error("Transaction was not archived successfully. Please try again!");
            });
        },
      );
    },
    transactionKey(key, defaultValue = null) {
      return this.extractDataKey(this.cashin, key, defaultValue);
    },
    suspicionInfo() {
      this.showSuspicionInfo = true;
    },
    downloadInvoice() {
      this.processing = true;
      this.$http
        .get(`api/v1/payments/invoices/${this.cashin.payin.id}`, { responseType: "blob" })
        .then((response) => this.convertResponse(response))
        .catch((error) => Notify.errorFromResponse(error, { close: true }))
        .finally(() => {
          this.processing = false;
        });
    },
    convertResponse(response) {
      const blob = new Blob([response], { type: response.type });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice-" + this.cashin.id);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    retryDeposit() {
      this.isRetrying = true;
      this.$http
        .get(`api/v1/transactions/deposit/retry/${this.transactionKey("payin.transaction_id")}`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({ name: "payins.index" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isRetrying = false));
    },
    retrySuspiciousDeposit() {
      this.showBypassComment = true;
    },
    rejectDeposit() {
      this.showRejectionComment = true;
    },
    startTransfer() {
      const method = "startCashin";
      Notify.confirm(`Please Confirm to start the transfer`).then(() => {
        this.$http
          .post(`api/v1/payments/${this.cashin.payin.id}/${method}`)
          .then(({ message }) => {
            Notify.success(message);
            this.$router.push({ name: "payins.index" });
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
    standbyTransfer() {
      this.standingByTransfer = true;
      this.$http
        .post(`api/v1/payments/${this.cashin.payin.id}/standBy`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({ name: "payins.index" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.standingByTransfer = false));
    },
    pendingTransfer() {
      this.pendingPaymentTransfer = true;
      this.$http
        .post(`api/v1/payments/${this.cashin.payin.id}/pending`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({ name: "payins.index" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.pendingPaymentTransfer = false));
    },
    bypassCommented({ message }) {
      Notify.success(message);
      this.$router.push({ name: "payins.index" });
    },
    rejectCommented({ message }) {
      Notify.success(message);
      this.$router.push({ name: "payins.index" });
    },
  },
};
</script>
